import React from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';

const ModalResultadoEnvio = ({ show, resultado, onFechar }) => {
  if (!resultado) return null;

  const { total_enviado, total_nao_enviado, falhas } = resultado;
  const total = total_enviado + total_nao_enviado;

  return (
    <Modal show={show} onHide={onFechar} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Resultado do Envio</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex mb-3" style={{ gap: 16 }}>
          <div className="text-center p-3 border rounded flex-fill">
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#28a745' }}>
              {total_enviado}
            </div>
            <div className="text-muted">Enviados</div>
          </div>
          <div className="text-center p-3 border rounded flex-fill">
            <div style={{ fontSize: '2rem', fontWeight: 'bold', color: '#dc3545' }}>
              {total_nao_enviado}
            </div>
            <div className="text-muted">Não Enviados</div>
          </div>
          <div className="text-center p-3 border rounded flex-fill">
            <div style={{ fontSize: '2rem', fontWeight: 'bold' }}>{total}</div>
            <div className="text-muted">Total</div>
          </div>
        </div>

        {falhas && falhas.length > 0 && (
          <>
            <h6>Erros de Envio</h6>
            <div style={{ maxHeight: 300, overflowY: 'auto' }}>
              <Table striped bordered size="sm">
                <thead>
                  <tr>
                    <th>Cliente</th>
                    <th>Celular</th>
                    <th>Motivo</th>
                    <th>DND</th>
                  </tr>
                </thead>
                <tbody>
                  {falhas.map((f, idx) => {
                    const ehDnd =
                      f.motivo &&
                      (f.motivo.toUpperCase().includes('DND') ||
                        f.motivo.toLowerCase().includes('do not disturb') ||
                        f.motivo.toLowerCase().includes('opt-out') ||
                        f.motivo.toLowerCase().includes('opted out') ||
                        f.motivo.toLowerCase().includes('blocked by user'));
                    return (
                      <tr key={`${f.codigo_conta}-${idx}`}>
                        <td>{f.nome}</td>
                        <td>{f.celular}</td>
                        <td className="text-danger">{f.motivo}</td>
                        <td>
                          {ehDnd && (
                            <Badge variant="warning">DND</Badge>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onFechar}>
          Fechar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalResultadoEnvio;
